import { Button, Col, Modal, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import DocumentViewer from '@common/components/DocumentViewer/DocumentViewer';
import { RetailerDocumentType } from '@common/models';
import useRetailerDocuments from '@core/hooks/useRetailerDocuments';
import { useSelectedMaterial } from '@ee-api/materials-api/useSelectedMaterial';

export interface CustomerExpecationModalProps {
    setAgreementSelected: React.Dispatch<React.SetStateAction<boolean>>;
    showCustomerExpecationModal: boolean;
    setShowCustomerExpecationModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CustomerExpectationModal = ({
    setAgreementSelected,
    setShowCustomerExpecationModal,
    showCustomerExpecationModal,
}: CustomerExpecationModalProps) => {
    const { t } = useTranslation();
    const { selectedValue: selectedMaterial } = useSelectedMaterial();

    const customerExpectationURL = useRetailerDocuments(
        RetailerDocumentType.CUSTOMER_EXPECTATIONS,
        selectedMaterial?.isInstalled
    );

    const handleCancel = () => {
        setShowCustomerExpecationModal(false);
    };
    const handleModalAgreeButton = () => {
        setAgreementSelected(true);
        setShowCustomerExpecationModal(false);
    };

    const CustomerExpectationModalFooter = () => {
        return (
            <Row wrap={false} justify={'space-between'} className="expectation-footer-content">
                <Col className="temp">
                    <a
                        className="pdf-download-text"
                        href={customerExpectationURL}
                        download
                        target="_blank"
                        rel="noreferrer"
                    >
                        {t('ORDER_SUMMARY.ESTIMATE_SECTION.CUSTOMER_EXPECTATION.DOWNLOAD_BUTTON')}
                    </a>
                </Col>
                <Col className="temp">
                    <div className="cancel-button" onClick={handleCancel}>
                        {t('ORDER_SUMMARY.ESTIMATE_SECTION.CUSTOMER_EXPECTATION.CANCEL_BUTTON')}
                    </div>
                    <AgreeButton />
                </Col>
            </Row>
        );
    };
    const CustomerExpectationModalContent = () => {
        return <DocumentViewer url={customerExpectationURL ?? ''} />;
    };

    const AgreeButton = () => {
        return (
            <Button className="agree-button" type="primary" onClick={handleModalAgreeButton}>
                <div className=".agree-button-content">
                    {t('ORDER_SUMMARY.ESTIMATE_SECTION.CUSTOMER_EXPECTATION.BUTTON')}
                </div>
            </Button>
        );
    };

    return (
        <Modal
            className="customer-expectation-modal"
            open={showCustomerExpecationModal}
            closable
            title={t('ORDER_SUMMARY.ESTIMATE_SECTION.CUSTOMER_EXPECTATION.TITLE')}
            onCancel={handleCancel}
            centered
            footer={null}
            width="75%"
        >
            <div className="modal-container">
                <div className="modal-content-container box-scroll">
                    <CustomerExpectationModalContent />
                </div>

                <div className="modal-footer-container">
                    <CustomerExpectationModalFooter />
                </div>
            </div>
        </Modal>
    );
};
